export default __webpack_public_path__ + "static/media/print.d851b692.svg";